/*
  SOTG wheel guard — see QA B2.

  Debutify renders several elements as `.slider` with `overflow-x: auto`. Chrome
  redirects a vertical wheel over a horizontally-scrollable, vertically-locked box
  into horizontal scrolling, and `scroll-snap-type: x mandatory` keeps snapping it
  back — so the page never scrolls at all. On this store that froze the homepage
  over the hero, the product row, and the marquee.

  Fixing each section in CSS is whack-a-mole and risks breaking real carousels, so
  instead: when a wheel event over a horizontal slider is predominantly VERTICAL,
  scroll the page and let the slider keep its horizontal gestures. Trackpad
  horizontal swipes and touch dragging are untouched (touch fires no wheel event).
*/
(function () {
  if (window.__sotgWheelGuard) return;
  window.__sotgWheelGuard = 1;

  document.addEventListener(
    'wheel',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var slider = target.closest('.slider');
      if (!slider) return;

      // Not a horizontal scroller — nothing to steal the gesture.
      if (slider.scrollWidth <= slider.clientWidth + 1) return;

      // Genuine horizontal intent (trackpad swipe, shift+wheel) — leave it alone.
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;
      if (event.shiftKey) return;

      // Vertical intent over a horizontal slider: give it back to the page.
      event.preventDefault();

      var amount = event.deltaY;
      if (event.deltaMode === 1) amount *= 16; // DOM_DELTA_LINE
      else if (event.deltaMode === 2) amount *= window.innerHeight; // DOM_DELTA_PAGE

      window.scrollBy(0, amount);
    },
    { passive: false, capture: true }
  );
})();
